import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { isValidUserId } from '../../../../../constants/Validators';
import { fetchUserStatusAction, saveNClose, verifyUserStatus } from '../../../store/actions/UserActions';
import { isEmpty } from 'lodash';
import { trackVerifyUsernameEvent, trackVerifyUsernameLoad } from '../../../../../utils/railsAnalytics';
import { irctcEducationPopup } from '../../../../../constants/AbConfigKeys';
import { trackClickEventProp61 } from '../../../../../utils/omnitureTracker';
import { GET_NEW_PASSWORD_RAILS_EDU_MODAL_TRACKING, TRAVELLERS_TRACKING_KEY,AADHAR_LINK } from '../../../../../constants/TrainConstants'
import { CHECK_IRCTC_USERNAME, TRACK_CHECKBOX, TRACK_CLOSE_BUTTON, TRACK_SAVE_N_CLOSE,LINK_AADHAR } from '../../IrctcEducationModal/Constants';

type VerifuUserNameState = {
  disabled: boolean,
  rotate: boolean,
  validationFail: boolean,
};

const initialStates = {
  disabled: true,
  rotate: false,
  validationFail: false,
};

export const useVerifyUserNameContainer = (props) => {
  const dispatch = useDispatch();
  const { user: { userStatus,aadharErrorFlow=false }, abConfig: { [irctcEducationPopup]: isIRCTCEducation } } = useSelector((state: any) => state);
  const [ state, setState ] = useState<VerifuUserNameState>(initialStates);
  const [ isChecked, setIsChecked] = useState(false);
  const [ isVerifiedId, setIsVerifiedId] = useState(false);
  const [ showModal, setShowModal ] = useState(props.showModal || false);
  const [ error, setError ] = useState( false);
  const [ irctcUserId, setIrctcUserId ] = useState(props.userStatus.userId);

  const timer = useRef(null);

  useEffect(() => {
    trackVerifyUsernameLoad();
    if (props.userStatus) {
      setIrctcUserId(props.userStatus.userId);
    }
    //clear timer on unMount
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  useEffect(()=>{
    if(isIRCTCEducation===1){
      setError(false);
    }
  },[irctcUserId])

  useEffect(() => {
    if (aadharErrorFlow && irctcUserId) {
      setError(true);
      setIsVerifiedId(true);
      setState({
        ...state,
        disabled: false,
      });
    }
  }, [aadharErrorFlow, irctcUserId])

  useEffect(() => {
    if(isIRCTCEducation === 1){
      setState({
        ...state,
        rotate: false,
      });
    }
    if (userStatus.error) {
      setError(userStatus.error);
    } else if ( userStatus.userId && userStatus.nextPage && state.rotate) {
      if(isIRCTCEducation === 0){
        goToVerifiedPage(userStatus);
      }
      else if(isIRCTCEducation === 1){
        if(userStatus.nextPage==='usernameVerified') setIsVerifiedId(true);
        else goToVerifiedPage(userStatus);
      }
    }
  }, [ props.userStatus ]);

  const goToVerifiedPage = (userStatus) => {
    // redirects to next user flow page according to the status received
    // nextPage property is set in Node backend.
    if (userStatus.nextPage === 'usernameVerified') {
      props.updateVerifiedUser(irctcUserId);
    } else if (!isEmpty(userStatus)) {
      props.switchModal(userStatus.nextPage, userStatus);
    }
  };

  const handleInputKeyUpViaParent = (val) => {
    setIrctcUserId(val);
    setIsVerifiedId(false);
    setIsChecked(false);
    setError(false);
    if (val && val.length > 0 && isValidUserId(val)) {
      setState({
        ...state,
        validationFail: false,
      });
    } else {
      setState({
        ...state,
        validationFail: true,
      });
    }

    if (val.length > 0) {
      if (isValidUserId(val)) {
        setState({
          ...state,
          validationFail: false,
        });
      } else {
        setState({
          ...state,
          validationFail: true,
        });
      }
    }

    if (val.length >= 3 && isValidUserId(val)) {
      setState({
        ...state,
        disabled: false,
      });
    } else {
      setState({
        ...state,
        disabled: true,
      });
    }
  };

  const handleCheck = (e) => {
    setIsChecked(e.target.checked);
    if(e.target.checked){
      trackClickEventProp61(TRAVELLERS_TRACKING_KEY, TRACK_CHECKBOX);
    }
  }

  const closeModalAction = ()=>{
    closeModal();
    trackClickEventProp61(TRAVELLERS_TRACKING_KEY, TRACK_CLOSE_BUTTON);
  }

  const saveClose = () => {
    trackClickEventProp61(TRAVELLERS_TRACKING_KEY, TRACK_SAVE_N_CLOSE);
    dispatch(saveNClose(userStatus));
    goToVerifiedPage(userStatus);
  }

  const goToIRCTCRegistrationPage = () => {
    trackVerifyUsernameEvent('create_irctc_account_clicked');
    props.createAccount();
  };

  const goToAadharMarketing = () => {
  trackClickEventProp61(TRAVELLERS_TRACKING_KEY,LINK_AADHAR);
  window.open(AADHAR_LINK,'_blank')
  };

  const goToForgotPassWordPage=() => {
    trackClickEventProp61(TRAVELLERS_TRACKING_KEY, GET_NEW_PASSWORD_RAILS_EDU_MODAL_TRACKING);
    props.switchModal('forgotPassword', userStatus);
  };

  const goToForgotUsernamePage = () => {
    trackVerifyUsernameEvent('irctc_forgot_username_clicked');
    props.switchModal('forgotUsername', userStatus);
  };

  const closeModal = () => {
    setError(false);
    setShowModal(false);
    props.closeModal();
  };

  const rotateLoader = () => {
    if (!state.disabled) {
      setState({
        ...state,
        rotate: true,
      });
      trackVerifyUsernameEvent('irctc_username_verify_clicked');
      dispatch(fetchUserStatusAction(irctcUserId));
    }
  };

  const checkIRCTCid = () => {
    if(!state.disabled){
      trackClickEventProp61(TRAVELLERS_TRACKING_KEY,CHECK_IRCTC_USERNAME);
      setState({
        ...state,
        rotate: true,
      });
      dispatch(verifyUserStatus(irctcUserId));

      timer.current = setTimeout(() => {
        setState({
          ...state,
          rotate: false,
        });
      }, 1500);
    }
  }

  return {
    props: {
      userStatus: (userStatus || props.userStatus),
      showModal,
      state,
      error,
      irctcUserId,
      isChecked,
      isVerifiedId,
      aadharErrorFlow
    },

    action: {
      handleCheck,
      saveClose,
      checkIRCTCid,
      rotateLoader,
      closeModalAction,
      closeModal,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      goToForgotPassWordPage,
      handleInputKeyUpViaParent,
      goToAadharMarketing
    },
  };
};
